export function toCytoscape(graph) {
    // Keep a mapping of all IDs so we can add their position when traversing the ELK graph
    const nodes = Object.entries(graph.nodes).map(([id, { parent, label, colorKey, size }]) => ({
        data: Object.assign({ id, parent, label, colorKey }, size),
    }));
    const edges = Object.entries(graph.edges).map(([id, { source, target, primary, label }]) => ({
        data: {
            id,
            source,
            target,
            primary: primary.toString(),
            label: label,
        },
    }));
    return { nodes, edges };
}
